import styled, { css } from 'styled-components'

import { sm } from '../../../../utils/device'

// PAX COUNTER STYLES STARTS
export const Pax = styled.div`
	width: 100%;
	margin-bottom: 16px;
	display: flex;
	flex-direction: row;
	align-items: center;
`

const CounterIcon = styled.i`
	width: 32px;
	height: 32px;
	line-height: 32px;
	font-size: 16px;
	letter-spacing: -0.231818px;
	text-align: center;
	color: #1895b3;
	background-color: #ffffff;
	border-radius: 100%;
	background-clip: padding-box;
	box-shadow: inset 0 0 0 1px #1895b3;
	cursor: pointer;

	display: flex;
	align-items: center;
	justify-content: center;

	${props =>
		props.disable &&
		css`
			color: #cccccc;
			box-shadow: inset 0 0 0 1px #cccccc;
			cursor: not-allowed;
		`};

	&:first-child {
		margin-right: auto;
	}
	&:last-child {
		margin-left: auto;
	}

	@media ${sm} {
		width: 28px;
		height: 28px;
		line-height: 28px;
	}
`

const CounterText = styled.span`
	vertical-align: middle;
	padding: 0 2px;
	font-size: 17px;
	line-height: 21px;
	letter-spacing: -0.231818px;
	color: #333333;
`
// PAX COUNTER STYLES ENDS

export const PaxCounter = ({
	count = 2,
	suffixText = 'Adults',
	incrementAction = () => {},
	decrementAction = () => {},
	isIncrementDisable = false,
	isDecrementDisable = false,
}) => {
	return (
		<Pax>
			<CounterIcon
				className="pyt-minus-16"
				onClick={() => {
					if (!isDecrementDisable) decrementAction(count - 1)
				}}
				disable={isDecrementDisable}
			/>
			<CounterText>
				{count} {suffixText}
			</CounterText>
			<CounterIcon
				disable={isIncrementDisable}
				className="pyt-plus-16"
				onClick={() => {
					if (!isIncrementDisable) incrementAction(count + 1)
				}}
			/>
		</Pax>
	)
}
